import Avery from '@averyano/core';

import { Detection } from './classes/Detection';

import NodeEmitter from './classes/NodeEmitter';
import FPSMeter from './classes/FPSMeter';
import CookieBanner from './components/CookieBanner';

import Experience from './components/Canvas/Experience';
import Navigation from './components/Navigation';
import Cursor from './components/Cursor';
import Preloader from './components/@avery-loader/Preloader';

import Lenis from '@studio-freight/lenis';

import { debounce, requestIdleCallbackPolyfill } from './utils/utils';
import ScrollTrigger from 'gsap/ScrollTrigger';
import GSAP from 'gsap';

// Pages
import HomePage from './pages/Home';
import DesignsPage from './pages/Designs';
import WebsitesPage from './pages/Websites';

import NotFound from './pages/NotFound';
import ContactPage from './pages/Contact';
import Footer from './components/Footer';
import CasePage from './pages/Case';
import CasesPage from './pages/Cases';
import PortfolioPage from './pages/Portfolio';
import ProductPage from './pages/Product';
import ProductsPage from './pages/Products';

// console.log(data);
import posthog from 'posthog-js';
import LocomotiveScroll from 'locomotive-scroll';
window.locale = 'en';
class App {
	constructor() {
		console.log(STOREPRODUCTS, STORESIZES, CASES, PRODUCTS);
		this.isCreated = false;
		this.scrollOnLoad = null;
		this.create();
		this.createContent();
		this.createPreloader();
		this.createNavigation();
		this.createCursor();
		this.registerNodeEvents();
	}

	create() {
		window.services = {
			// dev
			mobileOptimizedWebsite: true,
			advancedAnalytics: true,
			siteMaintenance: true,
			multipleLanguages: false,
			cms: false,
			ecommerce: false,
			// des
			web: true,
			visual: true,
			logo: false,
			brand: false,
			packaging: false,
			illustrations: false,
			threed: false,
		};
		console.log(window.services);
		requestIdleCallbackPolyfill();

		// Scroll — Locomotive Scroll v5 (Lenis-backed)
		this.scroll = new LocomotiveScroll({
			lenisOptions: {
				syncTouch: true,
				// easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
			},
			scrollCallback: (e) => {
				ScrollTrigger.update();
				this.updateMousePos(e);
				if (this.experience?.camera?.el && this.pageLength) {
					this.scrollPosition = 1.3 + window.scrollY / this.pageLength;
					this.experience.camera.el.position.z = this.scrollPosition;
					this.experience.speed = e.velocity * 0.002;
				}
			},
		});

		// Canvas
		this.experience = new Experience('.webgl');

		// FPS readout — hidden until backtick (`) is pressed
		this.fps = new FPSMeter();

		// Other
		this.addEventListeners();
		this.update();
	}

	createPreloader() {
		this.avery = new Avery({
			detection: Detection,
			loader: {
				pages: this.pages,
				preloader: this.preloader,
				onLeave: async () => {
					await this.preloader.show();
					this.scroll.destroy();
					this.footer.destroy();
					// this.experience.destroy();
					this.navigation.closeAll();
					this.avery.$emit('hideMenu');

					// kill all ScrollTrigger instances
					// ScrollTrigger.getAll().forEach((instance) => instance.kill());
				},
				beforeEnter: () => {
					console.log(`Before Enter ${this.avery.loader.template}`);
					this.preloader.selectorChildren.images =
						this.avery.loader.router.content.images;
					this.preloader.createComponent();
					this.preloader.createLoader(this.avery.loader.template);
				},
				onEnter: () => {
					// GlobalHandler.setTemplate = this.loader.template;
				},

				afterEnter: () => {
					this.experience.createLogoScene();

					this.scroll = new LocomotiveScroll({
						lenisOptions: { syncTouch: true },
						scrollCallback: (e) => {
							ScrollTrigger.update();
							this.updateMousePos(e);
							if (this.experience?.camera?.el && this.pageLength) {
								this.scrollPosition = 1.3 + window.scrollY / this.pageLength;
								this.experience.camera.el.position.z = this.scrollPosition;
								this.experience.speed = e.velocity * 0.002;
							}
						},
					});
					this.scroll.scrollTo('top', { immediate: true });
					this.footer.create();

					// if (this.loader.template === 'home') {
					// 	NodeEmitter.emit('hideMenu');
					// } else {
					// }
				},
				onPreloaded: async () => {
					console.log('CURRENT:', this.avery.loader.current.page);
					document.body.classList.remove('refresh');
					await this.avery.loader.current.page.show();
					this.avery.$emit('showMenu');
					this.navigation.updateNav(this.avery.loader.template);
					// this.footer.show();
					this.preloader.hide();

					this.onResize();
					setTimeout(() => {
						this.avery.loader.current.page.onResize();
					}, 100);

					console.log(this.avery.loader.template);
					if (this.avery.loader.template === 'store') {
						if (!this.footer.inVision) {
							this.footer.inVision = true;
							this.footer.update();
						}
					}
					console.log('onPreloaded');
				},
			},
		});

		// Loader
		this.id = document.querySelector('[data-page]').dataset.page;
		console.log('ID', this.id);
		if (this.id === 'home') {
			this.preloader.createLoader('home');
		}
		if (this.id === 'designs') {
			this.preloader.createLoader('designs');
		}
		if (this.id === 'websites') {
			this.preloader.createLoader('websites');
		}
		if (this.id === 'contact') {
			this.preloader.createLoader('contact');
		}
		if (this.id === 'case') {
			this.preloader.createLoader('case');
		}
		if (this.id === 'cases') {
			this.preloader.createLoader('cases');
		}
		if (this.id === 'portfolio') {
			this.preloader.createLoader('portfolio');
		}
		if (this.id === 'product') {
			this.preloader.createLoader('product');
		}
		if (this.id === 'products') {
			this.preloader.createLoader('products');
		}
		if (this.id === 'store') {
			this.preloader.createLoader('store');
		}
		if (this.id === 'productview') {
			this.preloader.createLoader('productview');
		}
		if (this.id === '404') {
			this.preloader.createLoader('notfound');
		}
		if (this.id === 'privacy-policy') {
			this.preloader.createLoader('privacy-policy');
		}
		if (this.id === 'refund-policy') {
			this.preloader.createLoader('refund-policy');
		}
		if (this.id === 'user-agreement') {
			this.preloader.createLoader('user-agreement');
		}
		if (!this.id) {
			this.preloader.createLoader('404');
		}

		console.log(this.avery);
		this.avery.start();
		this.avery.$on('scrollTo', (e) => {
			if (this.scroll) this.scroll.scrollTo(e);
		});

		this.avery.$on('scrollOnLoad', (e) => {
			this.scrollOnLoad = e;
		});

		this.experience.createLogoScene();
	}

	createNavigation() {
		this.navigation = new Navigation();

		if (this.id !== 'home') this.navigation.show();
	}

	createCursor() {
		if (!Detection.isMobile) this.cursor = new Cursor();
	}

	createContent() {
		this.preloader = new Preloader();
		this.mainDiv = document.querySelector('.main-div');

		// Pages
		this.home = new HomePage('.cover');
		this.designs = new DesignsPage('.designs');
		this.websites = new WebsitesPage('.websites');
		this.notfound = new NotFound('.notfound');
		this.contact = new ContactPage('.contact');
		this.case = new CasePage('.case');
		this.cases = new CasesPage('.cases');
		this.portfolio = new PortfolioPage('.portfolio');
		this.product = new ProductPage('.product');
		this.products = new ProductsPage('.products');
		// Routing
		this.pages = [
			{ page: this.home, url: ['/', '/home'] },
			{ page: this.designs, url: '/designs' },
			{ page: this.websites, url: '/websites' },
			{ page: this.contact, url: '/contact' },
			{
				page: this.case,
				url: '/case/:id',
				pointer: 'id',
				data: CASES[window.locale], // [{ id }, { id }, ..., { id }]
			},
			// TEMP hidden — restore to re-enable the /cases list page:
			// { page: this.cases, url: '/cases' },
			{ page: this.portfolio, url: '/portfolio' },
			{
				page: this.product,
				url: '/product/:id',
				pointer: 'id',
				data: PRODUCTS[window.locale],
			},
			{ page: this.products, url: '/products' },
			// 404 must stay last — Loader.findPageObjectByPath falls back to pages[length - 1]
			{ page: this.notfound, url: '/404' },
		];

		this.pageLength = this.mainDiv.getBoundingClientRect().height;
		this.isCreated = true;

		// Components
		this.footer = new Footer();
		this.footer.create();

		this.cookieBanner = new CookieBanner();
		this.cookieBanner.on('analytics:initialize', () => {
			console.log('analytics:initialize');

			const cookieAllowed = localStorage.getItem('cookieAllowed');
			window.cookiedAllowed = cookieAllowed === 'true';

			posthog.init('phc_n76IBu71hBCGW5mx8Pv5MrAB65OYaMsqkfRSqqY1XCS', {
				api_host: 'https://eu.i.posthog.com',
				person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
				// debug: true,
			});
			posthog.set_config({
				persistence: 'localStorage+cookie', // 'memory' when not allowed?
			});
			// posthog.opt_in_capturing();
		});
		this.cookieBanner.on('analytics:reject', () => {
			// posthog.opt_out_capturing();

			console.log('analytics:reject');
		});
	}

	registerNodeEvents() {
		this.avery.$on('openMenu', () => {
			this.navigation.openMenu();
		});

		this.avery.$on('closeMenu', () => {
			this.navigation.closeMenu();
		});

		this.avery.$on('showMenu', () => {
			this.navigation.show();
		});
		this.avery.$on('hideMenu', () => this.navigation.hide());

		this.avery.$on('stopScroll', () => this.scroll.stop());
		this.avery.$on('startScroll', () => this.scroll.start());
	}

	// onPreloaded() {
	// 	if (this.scrollOnLoad) {
	// 		this.scroll.scrollTo(this.scrollOnLoad);
	// 		this.scrollOnLoad = null;
	// 	}
	// 	this.loader.preloader.hide();
	// 	this.navigation.updateNav(this.loader.template);
	// 	NodeEmitter.emit('showMenu');
	// 	// if (this.loader.template === 'home')
	// 	// 	this.home.components.selection.getBounds();
	// 	if (this.loader.template === 'designs') {
	// 		this.designs.components.designProcess.on('stopScroll', () =>
	// 			this.scroll.stop()
	// 		);
	// 		this.designs.components.designProcess.on('startScroll', () =>
	// 			this.scroll.start()
	// 		);
	// 	}
	// }

	update(time) {
		if (this.fps) this.fps.tick(time);
		if (this.experience && this.experience.isReady) this.experience.update();
		if (this.home && this.home.update) this.home.update();
		if (this.designs && this.designs.update) this.designs.update();
		// portfolio's WebGL experience renders here; the DOM gallery still
		// self-drives its own input rAF (PortfolioPage.update guards by template)
		if (this.portfolio && this.portfolio.update) this.portfolio.update(time);

		this.frame = window.requestAnimationFrame(this.update.bind(this));
	}

	updateMousePos(e) {
		if (this.designs.isReady) {
			this.designs.updateMousePos(e);
		}
	}

	addEventListeners() {
		// @TODO handle all touch events here, and send values to buttons & canvas
		window.addEventListener('resize', debounce(this.onResize.bind(this))); // runs on the next frame
	}

	onResize() {
		if (this.experience && this.experience.isReady) this.experience.onResize();
		this.avery.loader.current.page.onResize();
	}
}

new App();
